import { render, staticRenderFns } from "./iconHeader.vue?vue&type=template&id=772938b8"
import script from "./iconHeader.vue?vue&type=script&lang=js"
export * from "./iconHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports